import { EntityDetailsSimpleItem } from '../../../../../../ui/components/EntitySectionList';
import PagerOutlinedIcon from '@juvare/common-web-ui/icons/PagerOutlined';
import { Box } from '@mui/material';
import React from 'react';
export const AccountPagerNumber = (props) => {
    const { pagerNumber, typographyVariant, iconColor } = props;
    return (React.createElement(Box, { sx: { display: 'flex', alignItems: 'center' }, "data-test": props['data-test'] },
        React.createElement(EntityDetailsSimpleItem, { showLabel: false, text: pagerNumber.number, textMaxWidth: 144, marginBottom: 0, typographyVariant: typographyVariant }),
        React.createElement(PagerOutlinedIcon, { fontSize: 'small', sx: { color: iconColor, mr: 1 } })));
};
